import { useAtom } from "jotai";
import { themeAtom } from "../../../../../-Atoms";
import { db, doc, updateDoc } from "../../../../../firebaseConfig";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import RemoveIcon from "@mui/icons-material/Remove";
import { motion } from "framer-motion";

import UniversalTextField from "../../../../../GlobalComponents/UniversalTextField";

const CateringItemV2 = ({
  item,
  items,
  setItems,
  index,
  showRemoveCateringItem,
  jobData,
  isDragging = false,
}) => {
  const [theme] = useAtom(themeAtom);

  const handleStoreChange = (newValue) => {
    const updatedItems = items.map((i, idx) =>
      idx === index ? { ...i, store: newValue } : i
    );
    setItems(updatedItems);
    // Save to Firestore
    updateDoc(doc(db, "JobData", jobData.id), { catering: updatedItems })
      .catch((e) => console.log(e));
  };

  const handleAmountChange = (newValue) => {
    const numericValue = newValue.replace(/[^0-9.]/g, "");
    const updatedItems = items.map((i, idx) =>
      idx === index ? { ...i, amount: numericValue } : i
    );
    setItems(updatedItems);
    // Save to Firestore
    updateDoc(doc(db, "JobData", jobData.id), { catering: updatedItems })
      .catch((e) => console.log(e));
  };

  const removeCateringItem = () => {
    const updatedItems = items.filter((_, idx) => idx !== index);
    setItems(updatedItems);
    updateDoc(doc(db, "JobData", jobData.id), { catering: updatedItems })
      .catch((e) => console.log(e));
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.2,
        ease: [0.25, 0.1, 0.25, 1.0],
      },
    },
  };

  return (
    <motion.div variants={itemVariants}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          width: "100%",
          borderRadius: "8px",
          backgroundColor: isDragging 
            ? (theme === "dark" 
                ? "rgba(100,150,255,0.25)" 
                : "rgba(100,150,255,0.30)") 
            : "transparent",
          padding: isDragging ? 1.5 : 0.5,
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          cursor: "grab",
          border: isDragging 
            ? `1px solid ${theme === "dark" ? "rgba(100,150,255,0.4)" : "rgba(100,150,255,0.5)"}` 
            : "1px solid transparent",
          "&:hover": {
            backgroundColor: theme === "dark" 
              ? "rgba(255,255,255,0.03)" 
              : "rgba(0,0,0,0.03)",
          },
          "&:active": {
            cursor: "grabbing",
          },
        }}
      >
        <Box sx={{ flex: 1 }}>
          <UniversalTextField
            value={item.store || ""}
            label="Store"
            onCallback={handleStoreChange}
            adminOnly={false}
            sx={{
              marginTop: 0,
              "& .MuiInputBase-root": {
                fontSize: "15px"
              },
              "& .MuiInputLabel-root": {
                fontSize: "15px"
              }
            }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Box>

        <Box sx={{ flex: 1 }}>
          <UniversalTextField
            value={item.amount || ""}
            label="Amount"
            onCallback={handleAmountChange}
            adminOnly={false}
            sx={{
              marginTop: 0,
              "& .MuiInputBase-root": {
                fontSize: "15px"
              },
              "& .MuiInputLabel-root": {
                fontSize: "15px"
              }
            }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Box>

        <IconButton
          sx={{
            display: showRemoveCateringItem ? "block" : "none",
            color: theme === "dark" ? "rgba(255,100,100,0.8)" : "rgba(200,50,50,0.8)",
            minWidth: "auto",
            width: "40px",
            height: "40px"
          }}
          onClick={removeCateringItem}
        >
          <RemoveIcon />
        </IconButton>
      </Box>
    </motion.div>
  );
};

export default CateringItemV2;
